import ImageEditorControl from './image-editor-control'
import ImageEditorColorControl from './image-editor-color-control'
import ImageEditorCropControl from './image-editor-crop-control'
import ImageEditorFiltersControl from './image-editor-filters-control'
import FabricImageControl from './fabric-image-control'

export default {
    ImageEditorControl,
    ImageEditorColorControl,
    ImageEditorCropControl,
    ImageEditorFiltersControl,
    FabricImageControl,
}
